import React, { useState, useEffect } from 'react';
import { TeamLogo } from './teamLogo';
import { getFallbackImage, convertStringToSlug } from '../utils';



/**
 * Player Box Component
 */
const PlayerBox = (props) => {
    const { 
        data = null,
        type = 'default',
        stat = null,
        link = null,
        ...restProps 
    } = props;

    // Pieces
    const [ name, setName ] = useState(null);
    const [ url, setUrl ] = useState(null);
    const [ image, setImage ] = useState(null);
    const [ teamID, setTeamID ] = useState(null);
    const [ teamName, setTeamName ] = useState(null);
    const [ statDisplay, setStatDisplay ] = useState(null);

    // Set up class list
    let classes = 'playerBox playerBox--' + type;

    useEffect(() => {
        if ( !data ) return;
        switch (type) {
            case 'stats':
                // Player Data
                if ( data.hasOwnProperty('player') && data.player ) {
                    setName(data.player.hasOwnProperty('shortName') && data.player.shortName ? data.player.shortName : data.player.name);
                    setImage(data.player.hasOwnProperty('picture') && data.player.picture ? data.player.picture : null);
                }
                // Team Data
                if ( data.hasOwnProperty('team') && data.team ) {
                    setTeamID(data.team.id);
                    setTeamName(data.team.name);
                }
                // Stats
                if ( stat && data.hasOwnProperty('value') && data.value ) {
                    setStatDisplay(
                        () => (
                            <div className="playerBox__stat">
                                <span className={"playerBox__statIcon playerBox__statIcon--" + stat}></span>
                                <span className="acaH5 playerBox__statNumber">{ data.value }</span>
                            </div>
                        )
                    );
                }
                break;
        }
    }, [data]);

    // Set the link
    useEffect(() => {
        if ( link ) {
            setUrl(link);
        }
    }, [link]);

    return (
        <a href={ url } className={classes}>
            <div className="playerBox__img">
                <TeamLogo defaultPictureId={image} fallback={getFallbackImage()} />
            </div>
            <div className="playerBox__content">
                <h4 className="acaH5">{ name }</h4>
                <div className="playerBox__team">
                    <TeamLogo teamId={teamID} fallback={getFallbackImage()} />
                    <p className="playerBox__teamName">{ teamName }</p>
                </div>
            </div>
            { statDisplay }
        </a>
    );
}



/**
 * Export
 */
export { PlayerBox };